export type IParaseURL = (
  urlString: string
) => { [key: string]: string; urlBase: string; urlParamString: string };

export function paraseURL(
  urlString: string
): { [key: string]: string; urlBase: string; urlParamString: string } {
  let i;
  let p;
  const b: { [key: string]: string; urlBase: string; urlParamString: string } = {
    urlBase: '',
    urlParamString: '',
  };
  let urlParamString;

  const urlSplit = urlString.split('?');
  const urlBase = urlSplit[0];
  urlParamString = urlSplit.length > 1 ? urlSplit[1] : '';

  b.urlBase = urlBase;
  b.urlParamString = urlParamString;

  // No query params are present, return object
  if (!urlParamString) {
    return b;
  }

  urlParamString = urlParamString.split('&');
  for (i = 0; i < urlParamString.length; i += 1) {
    p = urlParamString[i].split('=');
    if (p.length === 2) {
      b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, ' '));
    }
  }
  return b;
}
